

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required, url } from 'vuelidate/lib/validators';
import { ArticleAppConfig } from './models/ArticleApp';

@Component({
	mixins: [validationMixin],
	validations: {
		value: {
			image_url: { required, url },
			header_text: { required },
			body_text: { required },
			article_url: { required, url },
			link_label: { required },
		}
	}
})
export default class ContentHighlightsArticleAppEdit extends Vue {
	@Prop() public value: ArticleAppConfig;

	public markAsTouched(key: string & keyof ArticleAppConfig) {
		const field = this.$v.value[key];
		if (field) {
			field.$touch();
		}
		this.$emit('input', this.$v.$invalid);
	}

	public getErrorMessage(fieldName: string & keyof ArticleAppConfig, label: string): string | null {
		const field = this.$v.value[fieldName];
		if (field && field.$dirty && field.$invalid) {
			if (field.$params.required && !field.required) {
				return `${label} is required`;
			}
			if (field.$params.url && !field.url) {
				return `${label} must be a valid URL`;
			}
		}
		return null;
	}
}
